import { Shield, Heart, Users, CheckCircle } from 'lucide-react';
import { mockData } from '../mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  'shield-check': Shield,
  'heart-pulse': Heart,
  'pill': Shield,
  'users': Users,
  'shield': Shield,
  'clipboard-list': CheckCircle
};

export const ServicesGrid = () => (
  <section id="services" className="py-20 bg-gradient-to-b from-white to-slate-50">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Services</h3>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">Comprehensive insurance solutions tailored to your needs</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {mockData.services.map((service) => {
          const IconComponent = iconMap[service.icon];
          return (
            <Card key={service.id} className="border-2 hover:border-blue-300 transition-all hover:shadow-lg group">
              <CardHeader>
                <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors">
                  <IconComponent className="h-6 w-6 text-blue-600 group-hover:text-white transition-colors" />
                </div>
                <CardTitle className="text-xl">{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">{service.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
